export type PyramidsColumnGraphVariant = 'dashboard' | 'pyramidsView' | 'companySettings'

export type PyramidsColumnGraphVariantConfig = {
  classPrefix: 'dashboard-pyramids-graph' | 'pyramids-column-graph' | 'company-settings-pyramids-graph'
  modifierClass?: string
  barWidthPx: number
  trackHeightPx: number
  showDotValue: boolean
  highlightOutOfRange: boolean
}

export const PYRAMIDS_COLUMN_GRAPH_VARIANTS: Record<PyramidsColumnGraphVariant, PyramidsColumnGraphVariantConfig> = {
  dashboard: {
    classPrefix: 'dashboard-pyramids-graph',
    barWidthPx: 12,
    trackHeightPx: 110,
    showDotValue: true,
    highlightOutOfRange: true,
  },
  pyramidsView: {
    classPrefix: 'pyramids-column-graph',
    modifierClass: 'pyramids-column-graph--pyramids-view',
    barWidthPx: 12,
    trackHeightPx: 200,
    showDotValue: false,
    highlightOutOfRange: false,
  },
  companySettings: {
    classPrefix: 'company-settings-pyramids-graph',
    barWidthPx: 12,
    trackHeightPx: 240,
    showDotValue: false,
    highlightOutOfRange: false,
  },
}
